module.exports = __webpack_public_path__ + "img/socialgiver.742f3faf.png";